import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "../Layouts/MainLayout";
import Home from "../Pages/Home/Home";
import About from "../Pages/About/About";
import OurServices from "../Pages/OurServices/OurServices";
import Insights from "../Pages/Insights/Insights";
import FAQs from "../Pages/FAQs/FAQs";


import CQC_Reg from "../Sub-Pages/CQC_Registration";
import CQC_Mock from "../Sub-Pages/CQC_Mock";
import CQC_Sup from "../Sub-Pages/CQC_Support";
import CQC_Occu from "../Sub-Pages/CQC_Occupancy";
import CQC_Trai from "../Sub-Pages/CQC_Training";
import Care_Sale from "../Sub-Pages/Care_Sale";
import Care_Sell from "../Sub-Pages/Care_Sell";
import Acc_End from "../Sub-Pages/Acc_Endof";
import Acc_Payroll from "../Sub-Pages/Acc_Payroll";
import Acc_Capital from "../Sub-Pages/Acc_Capital";
import Acc_Financial from "../Sub-Pages/Acc_Financial";
import Soft_Rota from "../Sub-Pages/Soft_Rota";
import Soft_Governance from "../Sub-Pages/Soft_Governance";
import Soft_Audit from "../Sub-Pages/Soft_Audit";
import Soft_ERP from "../Sub-Pages/Soft_ERP";
import Soft_Allowances from "../Sub-Pages/Soft_Allowances";
import Opera_Setup from "../Sub-Pages/Opera_Setup"
import Opera_fullManag from "../Sub-Pages/Opera_fullManag"
import Registration from "../Pages/Registration/Registration";


import Blog_Registration from "../Blogs-Pages/Blog_Registration";
import Blog_CompGuide from "../Blogs-Pages/Blog_CompGuide";
import Blog_Beginners from "../Blogs-Pages/Blog_Beginners";
import Blog_Business from "../Blogs-Pages/Blog_Business";
import Blog_Compliance from "../Blogs-Pages/Blog_Compliance";
import Blog_DocNeeded from "../Blogs-Pages/Blog_DocNeeded";
import Blog_GuideSteps from "../Blogs-Pages/Blog_GuideSteps";
import Blog_RegManager from "../Blogs-Pages/Blog_RegManager";
import Blog_RegTake from "../Blogs-Pages/Blog_RegTake";




function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
         {/*  Home pages */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
           <Route path="/services" element={<OurServices />} />
            <Route path="Insights" element={<Insights />} />
             <Route path="FAQs" element={<FAQs />} />
             <Route path="Registration" element={<Registration />} />
                   {/*  Sub pages */}
          <Route path="/Sub-Pages/CQC_Registration" element={<CQC_Reg />} />
           <Route path="/Sub-Pages/CQC_Mock" element={<CQC_Mock />} />
            <Route path="/Sub-Pages/CQC_Support" element={<CQC_Sup />} />
             <Route path="/Sub-Pages/CQC_Occupancy" element={<CQC_Occu />} />
              <Route path="/Sub-Pages/CQC_Training" element={<CQC_Trai />} />
          <Route path="/Sub-Pages/Care_Sale" element={<Care_Sale />} />
           <Route path="/Sub-Pages/Care_Sell" element={<Care_Sell />} />
            <Route path="/Sub-Pages/Acc_Endof/" element={<Acc_End />} />
             <Route path="/Sub-Pages/Acc_Payroll/" element={<Acc_Payroll />} />
              <Route path="/Sub-Pages/Acc_Capital/" element={<Acc_Capital />} />
               <Route path="/Sub-Pages/Acc_Financial/" element={<Acc_Financial />} />
          <Route path="/Sub-Pages/Soft_Rota/" element={< Soft_Rota/>} />
           <Route path="/Sub-Pages/Soft_Governance/" element={< Soft_Governance/>} />
            <Route path="/Sub-Pages/Soft_Audit/" element={< Soft_Audit/>} />
             <Route path="/Sub-Pages/Soft_ERP/" element={<Soft_ERP />} />
              <Route path="/Sub-Pages/Soft_Allowances/" element={< Soft_Allowances/>} />
          <Route path="/Sub-Pages/Opera_Setup/" element={< Opera_Setup/>} />
           <Route path="/Sub-Pages/Opera_fullManag/" element={< Opera_fullManag/>} />
                      {/*  Blogs  pages */}
          <Route path="/Blogs-Pages/Blog_Registration/" element={<Blog_Registration/ >} />
          <Route path="/Blogs-Pages/Blog_CompGuide/" element={<Blog_CompGuide/ >} />
          <Route path="/Blogs-Pages/Blog_Beginners/" element={<Blog_Beginners/ >} />
          <Route path="/Blogs-Pages/Blog_Business/" element={<Blog_Business/ >} />
          <Route path="/Blogs-Pages/Blog_Compliance/" element={<Blog_Compliance/ >} />
          <Route path="/Blogs-Pages/Blog_DocNeeded/" element={<Blog_DocNeeded/ >} />
          <Route path="/Blogs-Pages/Blog_GuideSteps/" element={<Blog_GuideSteps/ >} />
          <Route path="/Blogs-Pages/Blog_RegManager/" element={<Blog_RegManager/ >} />
          <Route path="/Blogs-Pages/Blog_RegTake/" element={<Blog_RegTake/ >} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;